import { StepType } from '@de/types/enums';
import type { Component, DCS, Step } from '@de/types/types';

// Shared tokenizer so `getTypeInfo` and `getExperienceVariant` derive grains
// identically. `SNAKE_Case` → `snake-case`; empty/undefined → `''`.
export const formatGrainToken = (value: string | undefined): string =>
  value ? value.replace(/_/g, '-').toLowerCase() : '';

// DCS step's `variant`, COMPONENT step's `componentType`, else raw step `type`.
export const getStepGrainToken = (
  stepType: string | undefined,
  step: Step | undefined,
): string => {
  if (!stepType) return '';
  if (stepType === StepType.DCS) {
    return formatGrainToken((step as DCS | undefined)?.variant);
  }
  if (stepType === StepType.COMPONENT) {
    return formatGrainToken((step as Component | undefined)?.componentType);
  }
  return formatGrainToken(step?.type);
};
